import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M2 20a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1","key":"svg-0"}],["path",{"d":"M4 18l-1 -3h12m4 0h2l-.506 1.517","key":"svg-1"}],["path",{"d":"M11 11v1h1m4 0h2l-7 -9v4","key":"svg-2"}],["path",{"d":"M7.713 7.718l-1.713 4.282","key":"svg-3"}],["path",{"d":"M3 3l18 18","key":"svg-4"}]]

const IconSailboatOff = createReactComponent('outline', 'sailboat-off', 'SailboatOff', __iconNode);

export default IconSailboatOff;